<template>
  <header class="app-header">
    <img v-if="user !== ''" class="user-avatar" :src="user.profile_picture.data.url" :alt="user.first_name">
    <ul class="menu">
      <li>
        <router-link to="/">
          <icon-svg name="home"></icon-svg>
        </router-link>
      </li>
      <li>
        <router-link to="/new-game">
          <icon-svg name="racket-red"></icon-svg>
        </router-link>
      </li>
      <li>
        <router-link to="/history">
          <icon-svg name="calendar"></icon-svg>
        </router-link>
      </li>
    </ul>
  </header>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState(['user'])
    }
  }

</script>

<style lang="scss" scoped>

  .app-header {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: $color-secondary;
    z-index: 10;
    border-top: 1px solid $color-white;

    @include respond-to(medium) {
      padding: 1rem 2rem;
      top: 0;
      bottom: auto;
      background-color: transparent;
    }

  }

  .user-avatar {
    display: none;

    @include respond-to(medium) {
      display: inline-flex;
      @include size(3rem);
      border-radius: 50%;
      margin-right: 1rem;
    }
  }

  .menu {
    @include reset-list;
    display: flex;
    width: 100%;
    font-size: 2rem;
    text-transform: uppercase;

    li {
      width: (100% / 3);

      @include respond-to(medium) {
        width: auto;
      }

      a {
        color: $color-white;
        display: block;
        padding: 1rem;
        text-align: center;

        &.router-link-exact-active {
          color: $color-primary;
        }

        @include respond-to(medium) {
          display: inline-block;
          padding: 0 1rem;
          color: $color-white;

          &.router-link-exact-active {
            color: $color-primary;
          }
        }

      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue